<template>
  <div>
    <verte v-model="selected_color" picker="square" model="rgb">
        <svg viewBox="0 0 100 75">
          <rect class="cls-1" x="0.5" y="0.5" width="120" height="80"/>
        </svg>
    </verte>
    <input ref="color" type="hidden" :name="input_name" :value="selected_color">
  </div>
</template>
<style type="text/css">
  .verte__guide{
    width: 60px;
    height: 40px;
  }
</style>
<script>
  import Verte from 'verte';
  import 'verte/dist/verte.css';
  export default {
    components: { Verte }, // window.VueSwatches.default - from CDN
    props: { 
      color: {
        default: '#FF005C',
        type: String
      },
      name: {
        type: String
      }
    },
    data () {
      return {
        selected_color: this.color,
        input_name: this.name
      }
    }
  }
</script>
